var map = {
	"./cur_bg.png": "1082",
	"./goods_cart.png": "f950",
	"./goods_cart_cur.png": "c8f6",
	"./home.png": "47b9",
	"./home_cur.png": "b484",
	"./intention.png": "3548",
	"./intention_cur.png": "dc40",
	"./route.png": "a558",
	"./route_cur.png": "60a5",
	"./user.png": "19ea",
	"./user_cur.png": "4987"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0380";